'use strict'
import { default as Component } from '../component.js'
import { elementToggle, formTrackValidity, getErrorMessage, i18n, setActionStateMessageForTargets } from '../helper.js'

class Reorder extends Component
{
	async init()
	{
		this.view = App.View.cache('account/reorderDetail')
		this.model = this.view.model
		formTrackValidity(this.element)
		this.shippingAddressFormToggle(false)
		this.paymentMethodFormToggle(this.model.relationships?.walletCard ? 'WalletCard' : 'WalletCardNew')
		this.action = App.Action.cache(this.element.getAttribute('ui-action'))
		document.addEventListener('error', e => this.onError(e))
		document.addEventListener('action.before', e => this.onActionBefore(e))
		document.addEventListener('action.after', e => this.onActionAfter(e))
		Handlebars.registerHelper({
			getNextMonday: () => moment().startOf('isoWeek').add(1, 'week')
		})
	}

	shippingAddressFormToggle(show)
	{
		elementToggle(this.element.querySelector('[ui-shippingAddressDisplay]'), !show)
		elementToggle(this.element.querySelector('[ui-shippingAddressForm]'), show)
		if(show)
			this.element.querySelector('[name="shippingAddressId"]').value = '0';
	}

	paymentMethodFormToggle(paymentMethodId)
	{
		this.element.querySelector('[name="walletCard[id]"]').checked = paymentMethodId == 'WalletCard'

		this.element.querySelectorAll('[id^="checkoutPaymentMethod["]')
			.forEach(el => elementToggle(el, false))

		elementToggle(this.element.querySelector('[id^="checkoutPaymentMethod[' + paymentMethodId + ']"]'), true)
	}

	walletCardSelect(id)
	{
		const model = App.Store.model('walletcard', id)
		const input = this.element.querySelector('[type="radio"][name="walletCard[id]"]')
		const span = this.element.querySelector('[type="radio"][name="walletCard[id]"] ~ span')

		span.innerHTML = (model.attributes.nickname ? '<strong>' + model.attributes.nickname + '</strong><br />' : '')
			+ '<i class="fa fa-cc-' + model.attributes.network.toLowerCase() + '"></i> '
			+ model.attributes.network + ' <tt>&bull;&bull;&bull;&bull;' + model.attributes.lastFour + '</tt><br />'
			+ '<em>Expires ' + model.attributes.expirationMonth + '/' + model.attributes.expirationYear + '</em>'
		input.value = model.id

		this.paymentMethodFormToggle('WalletCard')
	}

	//#region Event handlers
	onActionBefore(e)
	{
		if (e.detail.canceled)
			return

		if (e.detail.name == 'reorder update')
		{
			if (!this.element.reportValidity())
			{
				e.preventDefault
				return
			}
			if (e.detail.data.walletCard.id)
			{
				const walletCardId = e.detail.data.walletCard.id
				delete e.detail.data.walletCard
				e.detail.data.walletCard = { id: walletCardId }
			}
			else if (!e.detail.data.walletCard.token)
			{
				e.preventDefault()
				App.Component.formCreditCard.prototype.setTokenCallBack(() =>
				{
					this.element.querySelector('input[type="submit"]').click()
				})
			}
		}
	}

	onActionAfter(e)
	{
		window.scrollTo(0, document.querySelector('[ui-view="account/reorderDetail"]')?.offsetTop ?? 0)

		if (e.detail.canceled || !e.detail.success)
			return

		if (e.detail.name == 'reorder clear paymentMethod')
			this.paymentMethodFormToggle('WalletCardNew')
		else if (e.detail.name == 'walletcardselect modal submit')
			this.walletCardSelect(e.detail.data.id)
		else if (e.detail.name == 'reorder clear shippingAddress')
			this.shippingAddressFormToggle(true)
		else if (e.detail.name == 'addressselect modal submit')
		{
			this.shippingAddressFormToggle(false)
			this.element.querySelector('[name="shippingAddressId"]').value = e.detail.data.id
			Object.entries(App.Store.model('address', e.detail.data.id).attributes).forEach(entry =>
			{
				const el = this.element.querySelector(`[ui-address-${entry[0]}`)
				if (el)
					el.innerHTML = entry[1]
				if (entry[0] === 'address2' && entry[1])
				{
					el.classList.remove('hidden')
					el.innerHTML += '</br>'
				}
				else if (entry[0] === 'address2')
					el.classList.add('hidden')
			})

		}
		else if (e.detail.name === 'reorder update')
		{
			setActionStateMessageForTargets(
				this.action,
				i18n('apex.ui.reorder.successmessage'),
				'success',
				e.target
			)
		}
	}

	onError(e)
	{
		e.preventDefault()
		setActionStateMessageForTargets(
			this.action,
			getErrorMessage(e),
			'fail',
			e.target
		)
	}
	//#endregion Event handlers
}

export default Reorder
